package ui.app.visibility

import androidx.compose.material3.SnackbarDuration
import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import api.AppType
import common.frontend.api.Io
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal

@VM
class AppVisibilityListingVM : NavigationViewModel() {

    private lateinit var scopeUi: AppVisibilityScope

    var state by mutableDataState<AppVisibilityScope.Wrapper>()
        private set

    val searchFiledCompany = mutableStateOf(TextFieldValue(""))
    val searchFiledAppVariant = mutableStateOf(TextFieldValue(""))


    sealed interface Action {
        data object Save : Action
        companion object {

            @Composable
            fun rememberAction(vm: AppVisibilityListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is Save -> vm.save()
                        }
                    }
                }
            }
        }
    }

    private fun save() {
        scope.launch {
            state.entry?.apply {
                runCatching {
                    Repository.api.app.visibilityChange(data)
                }.onFailure {
                    it.printStackTraceInDebug()
                    snackBarStateGlobal.showSnackbar(
                        message = it.message!!,
                        withDismissAction = true,
                        duration = SnackbarDuration.Long
                    )
                }.onSuccess {
                    confirmChanges()
                }
            }

        }
    }


    fun init(scopeUi: AppVisibilityScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                val data = Repository.api.app.visibilityListing().apply {
                    companyArr.forEach {
                        it.variants.sortWith(compareBy<Io.ListingAppManager.ItemCompany.AppVariantEntry> { AppType.RSS match it.type }
                            .thenBy { it.id })
                    }
                    variantArr.sortWith(compareBy<Io.ListingAppManager.ItemAppVariant> { AppType.RSS match it.type }
                        .thenBy { it.id })
                }
                state = DataState.Result(
                    AppVisibilityScope.Wrapper(data)
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
